export default __webpack_public_path__ + "static/fintracase1-1ee041ba095733278cb104485d5b6a85.png";